import { createContext } from 'react';

export const LoanActionsControlsContext = createContext(null);
